<template>
    <div>
      <Datepicker class="picker" :inline="true" @selected="selected" @changedMonth="changedMonth" @changedYear="changedYear" :language="ja" v-model="selectedValue" :highlighted="highlighted">
      </Datepicker>
    </div>
</template>
<script>
import firebase from '@firebase/app'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import {ja} from 'vuejs-datepicker/dist/locale'
export default {
  components: {
    Datepicker
  },
  data(){
    return{
      ja:ja,
      year_path: '',
      month_path:'',
      day_path: '',
      paramsName: '',
      highlighted:{dates:[]},
      selectedValue: '',
    }
  },
  computed: {
    user(){
      return this.$store.getters.user;
    }
  },
  watch:{
    '$route' (to) {
      this.$router.go(to.params.id)
    }
  },
  created(){
    var [ , paramsName, year_path, month_path, day_path] = location.pathname.split('/')
    this.year_path = year_path
    this.month_path = month_path
    this.day_path = day_path ? day_path : 1;
    this.paramsName = paramsName

    this.selectedValue = new Date(year_path, month_path -1, this.day_path) 

    firebase.firestore().collection('diary_text').doc(this.user.uid).collection(year_path + '_' + month_path).orderBy("day").get().then(snapshot => {
      snapshot.forEach(doc => {
      var data = doc.data()
      var index =  data.day
      this.highlighted.dates.push(new Date(year_path, month_path -1, index))
      })
    });
  },
  methods:{
    selected(Date){
        const d = moment(Date);
        const month = d.format("M")
        const day = d.format("D")
        if(this.paramsName == 'archive'){
            this.$router.push({ name: 'archive', params:{ id_year: this.year_path, id_month: month, id_day: day } })
        }
        if(this.paramsName == 'statistics'){
            this.$router.push({ name: 'statisticsDay', params:{ id_year: this.year_path, id_month: month, id_day: day } })
        }
    },
    changedMonth(changedMonth){
      console.log(changedMonth)
        if(changedMonth.timestamp){
          var timestamp_month = moment(changedMonth).subtract(1, 'month').format("M")
          var timestamp_year = moment(changedMonth).format("YYYY")
          console.log(timestamp_year)
          if(this.paramsName == 'archive'){
              this.$router.push({ name: 'archiveMonth', params:{ id_year: timestamp_year, id_month: timestamp_month } })
          }
          if(this.paramsName == 'statistics'){
              this.$router.push({ name: 'statisticsMonth', params:{ id_year: timestamp_year, id_month: timestamp_month } })
          }
        }else{
          var md_month = moment(changedMonth).format("M")
          var md_year = moment(changedMonth).format("YYYY")
          console.log(md_year)
          if(this.paramsName == 'archive'){
              this.$router.push({ name: 'archiveMonth', params:{ id_year: md_year, id_month: md_month } })
          }
          if(this.paramsName == 'statistics'){
              this.$router.push({ name: 'statisticsMonth', params:{ id_year: md_year, id_month: md_month } })
          }
        }
    },
    changedYear(changedYear){
      var year = moment(changedYear).format("YYYY")
      var month = moment(changedYear).format("M")
      if(this.paramsName == 'archive'){
              this.$router.push({ name: 'archiveMonth', params:{ id_year: year, id_month: month } })
      }
      if(this.paramsName == 'statistics'){
        this.$router.push({ name: 'statisticsMonth', params:{ id_year: year, id_month: month } })
      }
    }
  }
}
</script>

<style scoled>
  .picker div  {
      margin: auto;
      width: 100%;
  }
</style>